<template>
  <div
    class="bg-gradient-to-br from-white to-gray-50 rounded-xl shadow-xl border-0 p-6 hover:shadow-2xl transition-all duration-300">
    <div class="h-[400px]">
      <Bar :data="data" :options="options" />
    </div>
  </div>
</template>

<script>
import {
  Chart as ChartJS,
  Title,
  Tooltip,
  Legend,
  BarElement,
  CategoryScale,
  LinearScale,
  Colors,
} from "chart.js";
import { Bar } from "vue-chartjs";
import { computed, ref } from "vue";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  Colors
);

export default {
  name: "TotalSalesForYearReportGrapics",
  components: {
    Bar,
  },
  props: {
    datas: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const normalizedDatas = computed(() => {
      if (!props.datas || typeof props.datas !== "object") {
        return {};
      }

      return props.datas;
    });

    const labels = computed(() => Object.keys(normalizedDatas.value));

    const typePayments = computed(() => {
      const firstLabel = labels.value[0];
      const firstMonth = firstLabel
        ? normalizedDatas.value[firstLabel]
        : null;

      if (!firstMonth || typeof firstMonth !== "object") {
        return [];
      }

      return Object.keys(firstMonth);
    });

    const colorPalette = [
      { bg: 'rgba(99, 102, 241, 0.8)', border: 'rgba(99, 102, 241, 1)' },
      { bg: 'rgba(16, 185, 129, 0.8)', border: 'rgba(16, 185, 129, 1)' },
      { bg: 'rgba(245, 158, 11, 0.8)', border: 'rgba(245, 158, 11, 1)' },
      { bg: 'rgba(59, 130, 246, 0.8)', border: 'rgba(59, 130, 246, 1)' },
      { bg: 'rgba(236, 72, 153, 0.8)', border: 'rgba(236, 72, 153, 1)' },
    ];

    const data = computed(() => ({
      labels: labels.value,
      datasets: typePayments.value.map((typePayment, index) => ({
        label: typePayment.toUpperCase(),
        data: labels.value.map(
          (mes) => Number(normalizedDatas.value?.[mes]?.[typePayment] ?? 0)
        ),
        backgroundColor: colorPalette[index % colorPalette.length].bg,
        borderColor: colorPalette[index % colorPalette.length].border,
        borderWidth: 2,
        borderRadius: 6,
      })),
    }));

    const options = ref({
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          display: true,
          position: 'bottom',
          labels: {
            padding: 15,
            font: {
              size: 12,
              family: "'Inter', 'system-ui', sans-serif",
              weight: 500,
            },
            color: '#4B5563',
            usePointStyle: true,
            pointStyle: 'circle',
          },
        },
        title: {
          display: true,
          text: "Ventas del Año Actual por Mes",
          padding: {
            top: 10,
            bottom: 20,
          },
          font: {
            size: 18,
            family: "'Inter', 'system-ui', sans-serif",
            weight: 700,
          },
          color: '#1F2937',
        },
        tooltip: {
          backgroundColor: 'rgba(17, 24, 39, 0.95)',
          padding: 12,
          cornerRadius: 8,
          titleFont: {
            size: 13,
            weight: 600,
          },
          bodyFont: {
            size: 12,
          },
        },
      },
      scales: {
        y: {
          beginAtZero: true,
          stacked: false,
          border: {
            display: false,
          },
          grid: {
            display: false,
            drawBorder: false,
          },
          ticks: {
            font: {
              size: 12,
              family: "'Inter', 'system-ui', sans-serif",
              weight: 500,
            },
            color: '#6B7280',
            padding: 10,
          },
        },
        x: {
          stacked: false,
          border: {
            display: false,
          },
          grid: {
            display: false,
            drawBorder: false,
          },
          ticks: {
            font: {
              size: 12,
              family: "'Inter', 'system-ui', sans-serif",
              weight: 600,
            },
            color: '#1F2937',
            padding: 10,
          },
        },
      },
      barPercentage: 0.75,
      categoryPercentage: 0.85,
    });
    return {
      data,
      options,
    };
  },
};
</script>
